import React from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { NavigationBar, NavigationBarProps } from './NavigationBar';

interface Props {
    children: React.ReactNode;
    illustration: React.ReactNode;
    illustrationLeftSide?: boolean;
    disclaimer: React.ReactNode;
    showDisclaimer?: boolean;
    hideCloseBtn?: NavigationBarProps['hideCloseBtn'];
    fiverrLogo: NavigationBarProps['fiverrLogo'];
    hasBack: NavigationBarProps['hasBack'];
    goBack: NavigationBarProps['goBack'];
}

export const StepWrapper = ({
    children,
    illustration,
    illustrationLeftSide = false,
    showDisclaimer,
    disclaimer,
    fiverrLogo,
    hideCloseBtn,
    hasBack,
    goBack,
}: Props) => (
    <Stack gap="0" height="100%" direction={!illustrationLeftSide ? 'row' : 'rowReverse'}>
        <Container display={{ default: 'none', md: 'block' }} flex="1 0 0" overflow="hidden">
            {illustration}
        </Container>
        <Container display="flex" flex="1 0 0" overflow="auto">
            <Container
                display="flex"
                direction="column"
                flex="1"
                paddingX={{
                    default: '6',
                    sm: '10',
                }}
                paddingBottom={{
                    default: '6',
                    sm: '8',
                }}
            >
                <NavigationBar fiverrLogo={fiverrLogo} hasBack={hasBack} goBack={goBack} hideCloseBtn={hideCloseBtn} />
                <Container display="flex" direction="column" flex="1" paddingTop={{ default: '8', md: '0' }}>
                    {children}
                </Container>

                {showDisclaimer && <Container marginTop="auto">{disclaimer}</Container>}
            </Container>
        </Container>
    </Stack>
);
